/**
 * Unit Toggle Component
 *
 * Toggle button for switching between TiB (binary) and TB (decimal) units.
 */

import { ToggleButtonGroup, ToggleButton, Tooltip, Typography, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import type { DisplayUnit } from '../../hooks/useDisplayUnits';

interface UnitToggleProps {
  unit: DisplayUnit;
  onChange: (unit: DisplayUnit) => void;
  size?: 'small' | 'medium' | 'large';
}

export function UnitToggle({ unit, onChange, size = 'small' }: UnitToggleProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <ToggleButtonGroup
        value={unit}
        exclusive
        onChange={(_e, newUnit) => newUnit && onChange(newUnit)}
        size={size}
        aria-label="Display units"
      >
        <ToggleButton value="TiB" aria-label="Tebibytes (binary)">
          <Typography variant="body2">TiB</Typography>
        </ToggleButton>
        <ToggleButton value="TB" aria-label="Terabytes (decimal)">
          <Typography variant="body2">TB</Typography>
        </ToggleButton>
      </ToggleButtonGroup>

      <Tooltip
        title={
          <Box sx={{ fontSize: '0.75rem' }}>
            <strong>TiB (Binary)</strong>: 1 TiB = 1024⁴ bytes (ZFS standard)
            <br />
            <strong>TB (Decimal)</strong>: 1 TB = 1000⁴ bytes (manufacturer labels)
            <br />
            <br />
            1 TB ≈ 0.91 TiB
          </Box>
        }
        arrow
      >
        <InfoIcon
          sx={{ fontSize: '1rem', color: 'text.secondary', cursor: 'help' }}
        />
      </Tooltip>
    </Box>
  );
}
